// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresGridPublishBody = {
  poolId: string;
  gridId: string;
  doNotifyMembers: boolean;
};

export type typeSquaresGridPublishOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    grid: {
      gridId: string;
      gridState: "open" | "locked" | "live" | "final" | "void";
      publishStatus: "draft" | "published";
      hasNumbers: boolean;
    };
  };
};

export type typeSquaresGridPublishOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridPublishOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridPublishOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresGridPublishBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
    doNotifyMembers: { type: "boolean" },
  },
  required: ["poolId", "gridId", "doNotifyMembers"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresGridPublish(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresGridPublishBody);
  }

  return async function postSquaresGridPublish(
    payload: typeSquaresGridPublishBody,
  ): Promise<
    typeSquaresGridPublishOutput200 | typeSquaresGridPublishOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresGridPublish" failed before calling the network. #f63503de3fd9`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#f63503de3fd9" },
        },
        data: null,
      } as typeSquaresGridPublishOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/grid-publish`,
      httpMethod: "POST",
      options,
    })) as typeSquaresGridPublishOutput200 | typeSquaresGridPublishOutput400;
  };
}
